// 自动更新服务 - 管理周期任务的自动更新
import notificationService from '@/services/notificationService.js'

class AutoUpdateService {
    constructor() {
        this.isRunning = false
        this.intervalId = null
        this.store = null
    }

    // 初始化服务
    init(store, notificationCallback) {
        this.store = store
        this.notificationCallback = notificationCallback || notificationService
        console.log('AutoUpdateService 初始化完成')
    }

    // 启动自动更新服务
    start() {
        if (this.isRunning || !this.store) {
            console.warn('AutoUpdateService 已在运行或未初始化')
            return
        }

        // 检查store是否有autoUpdateSettings属性
        if (!this.store.autoUpdateSettings || !this.store.autoUpdateSettings.enabled) {
            console.log('自动更新功能已禁用')
            return
        }

        this.isRunning = true
        console.log('启动周期任务自动更新服务')

        // 立即执行一次检查
        this.checkAndUpdate()

        // 设置定时检查
        this.intervalId = setInterval(() => {
            this.checkAndUpdate()
        }, this.store.autoUpdateSettings.checkInterval)

        console.log(`自动更新间隔设置为 ${this.store.autoUpdateSettings.checkInterval / 1000} 秒`)
    }

    // 停止自动更新服务
    stop() {
        if (!this.isRunning) {
            console.warn('AutoUpdateService 未在运行')
            return
        }

        this.isRunning = false

        if (this.intervalId) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }

        console.log('周期任务自动更新服务已停止')
    }

    // 重启服务（用于设置变更后）
    restart() {
        this.stop()
        this.start()
    }

    // 检查并更新任务
    checkAndUpdate() {
        if (!this.store) {
            console.error('Store 未初始化')
            return
        }

        try {
            console.log('执行周期任务自动更新检查...')

            // 检查store是否有autoUpdateTasks方法
            if (typeof this.store.autoUpdateTasks === 'function') {
                const updatedCount = this.store.autoUpdateTasks()

                if (updatedCount > 0) {
                    console.log(`🔄 自动更新了 ${updatedCount} 个周期任务`)
                    this.notifyUpdate(updatedCount)
                } else {
                    console.log('✅ 没有需要更新的周期任务')
                }
            } else {
                console.warn('Store中没有autoUpdateTasks方法')
            }
        } catch (error) {
            console.error('❌ 自动更新任务时出错:', error)
        }
    }

    // 通知用户更新结果
    notifyUpdate(count) {
        if (this.notificationCallback) {
            // 如果有自定义通知回调，使用它
            if (typeof this.notificationCallback === 'function') {
                this.notificationCallback(`已自动重置 ${count} 个周期任务`, 'info')
            } else {
                // 否则使用全局通知服务
                this.notificationCallback.info(`已自动重置 ${count} 个周期任务`, '系统通知', 3000)
            }
        } else {
            // 否则使用全局通知服务
            notificationService.info(`已自动重置 ${count} 个周期任务`, '系统通知', 3000)
        }

        console.log(`📢 系统通知: 已自动重置 ${count} 个周期任务`)
    }

    // 手动触发更新
    manualUpdate() {
        return this.checkAndUpdate()
    }

    // 获取服务状态
    getStatus() {
        return {
            isRunning: this.isRunning,
            enabled: this.store?.autoUpdateSettings?.enabled || false,
            interval: this.store?.autoUpdateSettings?.checkInterval || 0,
            lastCheck: this.store?.autoUpdateSettings?.lastCheck || null,
            tasksNeedingUpdate: this.store?.tasksNeedingUpdate?.length || 0
        }
    }

    // 更新设置
    updateSettings(settings) {
        if (!this.store) return

        // 确保autoUpdateSettings存在
        if (!this.store.autoUpdateSettings) {
            this.store.autoUpdateSettings = {}
        }

        this.store.autoUpdateSettings = {
            ...this.store.autoUpdateSettings,
            ...settings
        }

        // 如果服务正在运行且设置有变化，重启服务
        if (this.isRunning) {
            this.restart()
        }

        console.log('自动更新设置已更新:', settings)
    }
}

// 创建单例实例
const autoUpdateService = new AutoUpdateService()

export default autoUpdateService

// 导出便捷方法
export const initAutoUpdate = (store, notificationCallback) => autoUpdateService.init(store, notificationCallback)
export const startAutoUpdate = () => autoUpdateService.start()
export const stopAutoUpdate = () => autoUpdateService.stop()
export const restartAutoUpdate = () => autoUpdateService.restart()
export const manualUpdate = () => autoUpdateService.manualUpdate()
export const getAutoUpdateStatus = () => autoUpdateService.getStatus()
export const updateAutoUpdateSettings = (settings) => autoUpdateService.updateSettings(settings)